import { createContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface SurveyData {
  lang: string;
}

export const LocalTranslationContext = createContext<{
  t: (key: string) => string;
} | null>(null);

export const useLocalTranslation = (surveyData: SurveyData) => {
  const { i18n } = useTranslation();

  const localTranslationProviderValue = useMemo(
    () => ({
      t: (key: string) => i18n.t(key, { lng: surveyData.lang }),
    }),
    [surveyData.lang, i18n]
  );

  return localTranslationProviderValue;
};
